import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateSalesDocument as UpdateSalesDocumentMutation,
    UpdateSalesDocumentVariables as UpdateSalesDocumentVariables,
    SalesDocumentUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_SALES_DOCUMENT from '../mutations/update-sales-document.graphql';

export const useUpdateQuote = (): {
    updateQuote: (arg1: SalesDocumentUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateSalesDocument, {loading, error}] = useMutation<
        UpdateSalesDocumentMutation,
        UpdateSalesDocumentVariables
    >(UPDATE_SALES_DOCUMENT);

    return {
        updateQuote: (input: SalesDocumentUpdateInput) => updateSalesDocument({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
